import { ResCallback } from "@interfaces/common";
import { CompanyContactT } from "@interfaces/company/company";
import { Moment } from "moment";

export enum DepartureScheduleType {
  DAY = "DAY",
  WEEK = "WEEK",
  MONTH = "MONTH",
  YEAR = "YEAR",
}

export type DepartureScheduleCompanyT = {
  id: number;
  name: string;
};

export type DepartureScheduleUserT = {
  id: number;
  name: string;
};

export type DepartureScheduleHistoryItemT = {
  id: number;
  companyId: number;
  userId: number;
  user: {
    name: string;
  };
  prescription: {
    id: number;
    companyId: number;
    createdAt: string;
  } | null;
  prescriptionId: number | null;
  file: string | null;
  comment: string | null;
  date: string;
  isAccepted: boolean;
};

export type DepartureSchedulePeriodDates = {
  type: "success" | "warning" | "not_departure" | "planned" | "system";
  date: string;  
}

export type DepartureSchedulePeriod = {
  status: "success" | "warning" | "not_departure" | "planned" | "danger";
  dates: DepartureSchedulePeriodDates[];
}

export type DepartureScheduleT = {
  id: number;
  company: DepartureScheduleCompanyT;
  user: DepartureScheduleUserT;
  address: string;
  contacts: CompanyContactT[];
  count_departure: {
    title: string;
    countDeparture: number;
    countDate: number;
    typeDate: DepartureScheduleType;
  };
  periods: DepartureSchedulePeriod[];
  history: DepartureScheduleHistoryItemT[];
};

export type DepartureScheduleCreateObject = {
  id?: number;
  companyId: number;
  userId: number;
  countDeparture: number;
  countDate: number;
  typeDate: DepartureScheduleType;
};

export type DepartureScheduleFiltersCompany = {
  id: number;
  name: string;
}

export type DepartureScheduleFiltersUser = {
  id: number;
  name: string;
}

export type DepartureScheduleFiltersCountDeparture = {
  title: string;
  typeDate: string;
  countDate: number;
  countDeparture: number;
}

export type DepartureScheduleFiltersT = {
  company: DepartureScheduleFiltersCompany[];
  users: DepartureScheduleFiltersUser[];
  address: string[];
  contact: CompanyContactT[];
  count_departure: DepartureScheduleFiltersCountDeparture[];
  statuses: string[];
}

export type DepartureScheduleQueryParams = {
  company?: number[];
  users?: number[];
  address?: string;
  contact?: number[];
  count_departure?: string[];
  statuses_month?: number[];
  statuses?: string[];
};

export const departureScheduleSortKeys = [
  "lastTrainingDateOrder",
  "companyOrder",
  "departmentOrder",
  "positionOrder",
  "employeeOrder",
  "programOrder",
  "protocolNumberOrder",
  "trainingDocumentNumberOrder",
  "trainingDateOrder",
  "daysBeforeTrainingOrder",
  "causeOrder",
  "noteOrder",
];

export type DepartureScheduleCalendarData = {
  company: string;
  dates: DepartureSchedulePeriodDates[];
}

export type DepartureScheduleCalendarDay = {
  day: Moment;
  status: string;
}

export type FetchDepartureSchedulePropsT = (params: {
  cb?: ResCallback<DepartureScheduleT[]>;
}) => void;

export type FetchDepartureScheduleOnePropsT = (params: {
  id: number;
  cb?: ResCallback<DepartureScheduleT>;
}) => void;

export type FetchDepartureScheduleFiltersPropsT = (params: {
  cb?: ResCallback<DepartureScheduleFiltersT>;
}) => void;

export type TableRowPropsT = {
  item: DepartureScheduleT;
  isUser: boolean;
  onAddHistory: (type: "planned" | "full", value: DepartureScheduleT) => void;
  onRemoveHistoryItem: (id: number) => void;
  onEditHistoryItem: (value: DepartureScheduleHistoryItemT) => void;
  onAccepted: (accepted: boolean, id: number) => void;
};
